import { render, staticRenderFns } from "./campusTarget.vue?vue&type=template&id=6b192878&"
import script from "./campusTarget.vue?vue&type=script&lang=js&"
export * from "./campusTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports